// extracted by mini-css-extract-plugin
export var body = "contact-module--body--Htzbl";
export var contact = "contact-module--contact--h0NHl";
export var email = "contact-module--email--hY92z";
export var footer = "contact-module--footer--y+vlQ";
export var socialDiv = "contact-module--socialDiv--wiRoM";
export var title = "contact-module--title--IorzL";